<template>
    <div>
        <modal-dialog classes="modal__charity" :show="show" @close="close">
            <div class="charity__header">
                <p>The last Wednesday of<br>
                every month is our Charity Gift Day.<br>
                <small><em>Except December when it's the first Wednesday.</em></small>
                </p>
                <div class="charity__donation">
                    <div class="charity__donation-percentage">
                        <p>
                            2<small>&percnt;</small>
                        </p>
                    </div>
                    <div class="charity__donation-content">
                        <p>of today's total order<br>
                        value will be donated to...</p>
                    </div>
                </div>
            </div>
            <img src="/img/orbital/charity/prostate-cancer-uk-logo.png" alt="Prostate Cancer UK Logo">

            <div class="charity__content">
                <p>In addition to this, 100% of the donations<br>
                made at checkout will go to Prostate Cancer UK. </p>

                <p><strong>Make a difference and dontate today!</strong></p>

                <a href="/charity-day" class="btn btn-blue btn-sm">View Last Months Total</a>
            </div>
        </modal-dialog>
    </div>
</template>

<script>
    import ModalDialog from '../ModalDialog.vue';

    export default {
        components: {
            ModalDialog,
        },
        data() {
            return {
                show: false // Turn off by default so it doesn't flicker.
            }
        },
        mounted() {
            const hasCharityCookie = getCookie('charity_modal');
            if (!hasCharityCookie) {
                this.show = true;
                window.createCookie('charity_modal', true);
            }
        },
        methods: {
            close() {
                this.show = false;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/Modals/CharityDayModal.vue